export default class AnalysisControlBase {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, modalWrapper) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.modalWrapper = modalWrapper;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.panelId = 'analysis-panel-' + this.classId + '-' + this.action.Id;
        this.cancelId = this._id('cancel');
        this.saveId = this._id('save');
        this.active = false;
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', () => {
            if (this.active) {
                this._hidePanel();
            } else {
                this._showPanel();
            }
        });
    }

    _id(name) {
        return this.panelId + '--' + name;
    }

    _$(name) {
        return $('#' + this._id(name));
    }

    _combo(name) {
        return this._$(name).data('kendoComboBox');
    }

    _showPanel() {
        this._ensureAnalysisStyles();
        $('#' + this.modalWrapper)[0].innerHTML = this._getPanelTemplate();
        this._nameEdited = false;
        this._wireCommonEvents();
        this._wireWizardEvents();
        $('#' + this.elementId).addClass('selected');
        this.active = true;
    }

    _ensureAnalysisStyles() {
        if (document.getElementById('xp-analysis-picker-styles')) return;

        const style = document.createElement('style');
        style.id = 'xp-analysis-picker-styles';
        style.textContent =
            '.xp-analysis-settings-modal .general-settings-panel {' +
            'max-height:85vh;display:flex;flex-direction:column;' +
            '}' +
            '.xp-analysis-settings-modal .panel-content.xp-analysis-form {' +
            'overflow:hidden;overflow-y:auto;flex:1 1 auto;min-height:0;' +
            '}' +
            '.xp-analysis-settings-modal .panel-content.xp-analysis-footer {' +
            'flex:0 0 auto;' +
            '}' +
            '.xp-analysis-settings-modal .xp-analysis-modal-header {' +
            'background:var(--theme-primary-700);padding:10px 14px;' +
            'margin:-8px 0 12px 0 !important;width:100%;' +
            '}' +
            '.xp-analysis-settings-modal .xp-analysis-modal-header .general-settings-title {' +
            'color:#fff;font-weight:600;margin:0 !important;font-size:14px;line-height:1.4;' +
            '}' +
            '.xp-analysis-section-title {' +
            'display:flex;align-items:center;gap:10px;' +
            'margin:14px 0 10px 0;padding:0;' +
            'font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;' +
            'color:var(--theme-primary-700);' +
            '}' +
            '.xp-analysis-section-title::after {' +
            'content:"";flex:1;height:1px;background:var(--theme-primary-700);opacity:0.25;' +
            '}' +
            '.xp-analysis-section-title:first-child {' +
            'margin-top:0;' +
            '}' +
            '.xp-analysis-settings-modal .form-label {' +
            'font-size:12px;margin-bottom:3px;color:#555;font-weight:500;' +
            '}' +
            '.xp-analysis-settings-modal .col-6.mb-3,' +
            '.xp-analysis-settings-modal .col-3.mb-3,' +
            '.xp-analysis-settings-modal .col-12.mb-3 {' +
            'margin-bottom:10px !important;' +
            '}' +
            '.xp-analysis-field-header {' +
            'display:flex;align-items:center;justify-content:space-between;' +
            'gap:8px;margin-bottom:6px;' +
            '}' +
            '.xp-analysis-field-actions {' +
            'display:flex;align-items:center;gap:6px;font-size:11px;' +
            '}' +
            '.xp-analysis-field-count {' +
            'color:#888;margin-right:4px;' +
            '}' +
            '.xp-analysis-field-toggle {' +
            'color:var(--theme-primary-700);cursor:pointer;text-decoration:none;' +
            '}' +
            '.xp-analysis-field-toggle:hover {' +
            'text-decoration:underline;' +
            '}' +
            '.xp-analysis-field-sep {' +
            'color:#ccc;' +
            '}' +
            '.xp-analysis-field-filter {' +
            'width:100%;height:26px;font-size:12px;margin-bottom:6px;' +
            'padding:0 8px;border:1px solid #ddd;border-radius:4px;' +
            'box-sizing:border-box;background:#fff;' +
            '}' +
            '.xp-analysis-field-filter:focus {' +
            'outline:none;border-color:var(--theme-primary-700);' +
            '}' +
            '.xp-analysis-field-list {' +
            'border:1px solid #E5E5E5;border-radius:4px;' +
            'max-height:240px;overflow-y:auto;' +
            'background:#fff;padding:2px 0;' +
            '}' +
            '.xp-analysis-field-row {' +
            'display:flex;align-items:center;gap:8px;' +
            'padding:4px 10px;margin:0;cursor:pointer;' +
            'transition:background 0.1s ease;user-select:none;font-weight:normal;' +
            '}' +
            '.xp-analysis-field-row:hover {' +
            'background:#f5f7fa;' +
            '}' +
            '.xp-analysis-field-row input[type="checkbox"] {' +
            'margin:0;cursor:pointer;flex-shrink:0;' +
            '}' +
            '.xp-analysis-field-row span {' +
            'font-size:13px;color:#333;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;' +
            '}' +
            '.xp-analysis-invalid,' +
            '.xp-analysis-invalid.k-widget,' +
            '.xp-analysis-invalid .xp-analysis-field-list {' +
            'border:1px solid #dc3545 !important;border-radius:4px;' +
            'box-shadow:0 0 0 2px rgba(220,53,69,0.18) !important;' +
            '}';

        document.head.appendChild(style);
    }

    _section(titleKey) {
        return `<div class="col-12 xp-analysis-section-title">${this.resourcesHandler.get(titleKey)}</div>`;
    }

    _hidePanel() {
        const wrapper = $('#' + this.modalWrapper);
        if (wrapper.length > 0) {
            kendo.destroy(wrapper);
            wrapper[0].innerHTML = '';
        }
        $('#' + this.elementId).removeClass('selected');
        this.active = false;
    }

    _wireCommonEvents() {
        $('#' + this.cancelId).on('click', () => this._hidePanel());
        $('#' + this.saveId).on('click', () => this._onSave());
        // curăță marcajul de eroare când utilizatorul reia câmpul
        $('#' + this.panelId).on('focusin.analysis change.analysis', '.xp-analysis-invalid', function () {
            $(this).removeClass('xp-analysis-invalid');
        });
        // odată ce utilizatorul editează numele, nu îl mai suprascriem automat (gol => reia auto-denumirea)
        $('#' + this._id('analysis-name')).on('input', (evt) => {
            this._nameEdited = evt.target.value.trim() !== '';
        });
    }

    // Nume implicit al stratului rezultat, calculat din selecțiile curente; subclasa suprascrie.
    _defaultLayerName() {
        return '';
    }

    _refreshAutoName() {
        if (this._nameEdited) {
            return;
        }
        const name = this._defaultLayerName();
        if (name != null && name !== '') {
            this._$('analysis-name').val(name);
        }
    }

    _onSave() {
        this._clearValidation();
        const errors = (this._validate() || []).filter(e => e != null);
        if (errors.length > 0) {
            this._showValidationErrors(errors);
            return;
        }
        // funcționează indiferent dacă _buildAnalysisPayload întoarce o valoare sau un Promise
        Promise.resolve(this._buildAnalysisPayload()).then(result => {
            if (result == null) {
                return;
            }
            this._saveAnalysis(result);
            this._hidePanel();
        }).catch(err => {
            toastr.error(err != null && err.message != null ? err.message : String(err));
        });
    }

    // Întoarce lista erorilor de validare ({ name|selector, message }); implicit fără erori.
    _validate() {
        return [];
    }

    _showValidationErrors(errors) {
        errors.forEach(e => this._markInvalid(e));
        const list = errors.map(e => '• ' + e.message).join('<br>');
        toastr.warning(list, this.resourcesHandler.get('Analysis_ValidationTitle'), { escapeHtml: false });
    }

    _clearValidation() {
        $('#' + this.panelId + ' .xp-analysis-invalid').removeClass('xp-analysis-invalid');
    }

    _markInvalid(e) {
        const $el = e.selector != null ? $(e.selector) : this._invalidTarget(e.name);
        if ($el != null && $el.length > 0) {
            $el.addClass('xp-analysis-invalid');
        }
    }

    _invalidTarget(name) {
        const combo = this._combo(name);
        if (combo != null && combo.wrapper != null) {
            return combo.wrapper;
        }
        const numeric = this._$(name).data('kendoNumericTextBox');
        if (numeric != null && numeric.wrapper != null) {
            return numeric.wrapper;
        }
        return this._$(name);
    }

    // Validează un combo obligatoriu; întoarce eroare sau null.
    _vCombo(name, labelKey) {
        const combo = this._combo(name);
        const value = combo != null ? combo.value() : null;
        return value == null || value === '' ? this._requiredError(name, labelKey) : null;
    }

    // Validează un câmp numeric obligatoriu; întoarce eroare sau null.
    _vNumeric(name, labelKey) {
        const widget = this._$(name).data('kendoNumericTextBox');
        const value = widget != null ? widget.value() : null;
        return value == null ? this._requiredError(name, labelKey) : null;
    }

    // Cel puțin un câmp de ieșire bifat în listele de câmpuri țintă.
    _vTargetFields() {
        const checked = $('#' + this.panelId + ' .target-field-items:checked').length;
        if (checked > 0) {
            return null;
        }
        return {
            selector: '#' + this._id('first-source-target-fields') + ',#' + this._id('second-source-target-fields'),
            message: this.resourcesHandler.get('Analysis_ValidationTargetFields')
        };
    }

    _requiredError(name, labelKey) {
        const label = this.resourcesHandler.get(labelKey);
        return { name: name, message: this.resourcesHandler.get('Analysis_ValidationRequired').replace('{0}', label) };
    }

    _saveAnalysis(data) {
        let analyses = {};
        if (sessionStorage.getItem('xp_analysis') != null) {
            analyses = JSON.parse(sessionStorage.getItem('xp_analysis'));
        }
        const id = this._generateGuid();
        analyses[id] = data;
        sessionStorage.setItem('xp_analysis', JSON.stringify(analyses));
        $event.notify('analysisAdded', { id: id }, this, this.classId);
    }

    _entityComboOptions(onFieldsLoaded) {
        return {
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: (options) => {
                        $.ajax({
                            type: 'GET',
                            url: this.rootURL + 'Map/GetMapEntities?idMap=' + this.mapControl.mapId,
                            dataType: 'json',
                            success: (entities) => {
                                const items = entities.map(e => Object.assign({}, e, {
                                    Kind: e.Id < 0 ? 'ExtEntity' : 'Entity',
                                    Key: e.Name
                                }));
                                if (this._includeAnalyses()) {
                                    this._loadStoredAnalyses().forEach(a => items.push(a));
                                }
                                options.success(items);
                            },
                            error: (xhr) => options.error(xhr)
                        });
                    }
                }
            },
            change: (evt) => {
                const value = evt.sender.dataSource.data().find(row => row.Id == evt.sender.value());
                if (value == null) {
                    return;
                }
                this._refreshAutoName();
                const analyseControl = this;
                // if (value.Kind === 'Analysis') {
                //     onFieldsLoaded(value, this._fieldsFromAnalysis(value.XpQuery));
                //     return;
                // }
                // const url = value.Kind === 'ExtEntity'
                //     ? this.rootURL + 'extconn/getextfields?idExtEntity=' + Math.abs(value.Id)
                //     : this.rootURL + 'entity/GetFieldsByEntityId?idEntity=' + value.Id;
                // $.ajax({
                //     type: 'GET',
                //     url: url,
                //     async: true,
                //     contentType: 'application/json; charset=utf-8',
                //     success: (result) => {
                //         if (value.Kind === 'ExtEntity') {
                //             result.forEach(item => { item.FieldName = item.Name; });
                //         }
                //         onFieldsLoaded(value, result);
                //     }
                // });
                if (value.Kind === 'Analysis') {
                    var postData = value.XpQuery;
                    $.ajax({
                        type: "POST",
                        data: JSON.stringify(postData),
                        url: this.rootURL + "XpQuery/GetDataSourceFields?type=XPQUERY_INSTANT",
                        contentType: "application/json; charset=utf-8",
                        async: false,
                        success: function (result) {
                            if (result.error != null) {
                                toastr.error(result.error);
                            }
                            else if (result != null) {
                                const fields = [];
                                for (var i = 0; i < result.length; i++) {
                                    const col = result[i];
                                    if (col.Attr[0] == 'GEOMETRY' && col.Attr[2] == null) {
                                        col.Attr[2] = analyseControl.mapControl.map.getView().getProjection().getCode();
                                    }
                                    fields.push({
                                        FieldName: col.Name,
                                        Id: col.Id,
                                        DataType: col.Attr[0],
                                        Description: col.Attr[1],
                                        Srid: col.Attr[2],
                                    });
                                }
                                value.fields = fields;
                                onFieldsLoaded(value, fields);
                            }
                        }
                    });
                }
                else {
                    const url = value.Kind === 'ExtEntity'
                        ? this.rootURL + 'extconn/getextfields?idExtEntity=' + Math.abs(value.Id)
                        : this.rootURL + 'entity/GetFieldsByEntityId?idEntity=' + value.Id;
                    $.ajax({
                        type: 'GET',
                        url: url,
                        async: true,
                        contentType: 'application/json; charset=utf-8',
                        success: (result) => {
                            if (value.Kind === 'ExtEntity') {
                                result.forEach(item => { item.FieldName = item.Name; });
                            }
                            value.fields = result;
                            onFieldsLoaded(value, result);
                        }
                    });
                }
                
            }
        };
    }

    _includeAnalyses() {
        return true;
    }

    _loadStoredAnalyses() {
        const raw = sessionStorage.getItem('xp_analysis');
        if (raw == null) {
            return [];
        }
        const analyses = JSON.parse(raw);
        return Object.keys(analyses).map(id => {
            const def = analyses[id];
            return {
                Id: id,
                Name: def.layerName,
                Key: this._sanitizeDataSourceKey(def.layerName),
                Kind: 'Analysis',
                XpQuery: this._xpQueryCore(def),
                PkField: def.pkField
            };
        });
    }

    _sanitizeDataSourceKey(name) {
        return String(name).replace(/[^\w]/g, '_');
    }

    _xpQueryCore(def) {
        const core = {
            analyseType: def.analyseType || def.type || 'Complex',
            dataSource: def.dataSource,
            outputValues: def.outputValues
        };
        if (def.Parameters) {
            core.Parameters = def.Parameters;
        }
        return core;
    }

    _fieldsFromAnalysis(xpQuery) {
        const outputs = xpQuery && xpQuery.outputValues ? xpQuery.outputValues : [];
        return outputs
            .map(ov => ov.outputName || ov.fieldName)
            .filter(name => name != null && name !== '')
            .map(name => ({
                Id: name,
                Name: name,
                FieldName: name,
                Srid: null
            }));
    }

    _fieldsComboOptions() {
        return {
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: []
        };
    }

    _setComboData(name, data) {
        const ds = new kendo.data.DataSource({ data: data });
        ds.read();
        const cb = this._combo(name);
        cb.setDataSource(ds);
        if (data.length == 1) {
            cb.value(data[0].Id);
        }
        else {
            cb.value(null);
        }        
    }

    _selectedRow(name) {
        const cb = this._combo(name);
        if (cb == null) {
            return null;
        }
        return cb.dataSource.data().find(row => row.Id == cb.value());
    }

    _getPanelTemplate() {
        return `<div class="general-settings-wrapper panel config-modal xp-analysis-settings-modal" id="${this.panelId}">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content xp-analysis-form pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row m-0 col-12 xp-analysis-modal-header">
                                <label class="form-label general-settings-title">${this._getPanelTitle()}</label>
                            </div>
                            <div class="form-row mb-0 pl-3 pr-3 pt-2">
                                ${this._getFormBody()}
                            </div>
                        </div>
                        <div class="panel-content xp-analysis-footer border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="${this.cancelId}" class="btn btn-secondary ml-auto" title="${this.resourcesHandler.get('CancelChanges')}" type="button">${this.resourcesHandler.get('Cancel')}</button>
                            <button id="${this.saveId}" class="btn btn-primary ml-2" title="${this.resourcesHandler.get('SaveChanges')}" type="button">${this.resourcesHandler.get('Execute')}</button>
                        </div>
                    </div>
                </div>`;
    }

    _getActionButtonTemplate() {
        const div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="${this.elementId}" title="${this._getTitle()}">
                                <i class="${this.action.Icon}"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }
        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }

    _generateGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    _renderTargetFields(isFirst, fields) {
        const containerId = this._id(isFirst ? 'first-source-target-fields' : 'second-source-target-fields');
        const itemsId = this._id(isFirst ? 'first-source-target-field-items' : 'second-source-target-field-items');
        const countId = this._id(isFirst ? 'first-source-target-count' : 'second-source-target-count');
        const filterId = this._id(isFirst ? 'first-source-target-filter' : 'second-source-target-filter');
        const datasourceTag = isFirst ? 'first' : 'second';
        const label = this.resourcesHandler.get(isFirst ? 'Analysis_TargetFieldsSource1' : 'Analysis_TargetFieldsSource2');
        const r = this.resourcesHandler;

        let itemsHtml = '';
        fields.forEach(x => {
            itemsHtml += `<label class="xp-analysis-field-row">
                <input class="target-field-items" type="checkbox" ref-id="${x.Id}" datasource="${datasourceTag}"/>
                <span>${x.FieldName}</span>
            </label>`;
        });

        const html = `<div class="col-12 mb-3">
                        <div class="form-group mb-0">
                            <div class="xp-analysis-field-header">
                                <label class="form-label m-0">${label}:</label>
                                <div class="xp-analysis-field-actions">
                                    <span class="xp-analysis-field-count" id="${countId}">0 / ${fields.length}</span>
                                    <a class="xp-analysis-field-toggle" data-action="all">${r.get('Analysis_All')}</a>
                                    <span class="xp-analysis-field-sep">|</span>
                                    <a class="xp-analysis-field-toggle" data-action="none">${r.get('Analysis_None')}</a>
                                </div>
                            </div>
                            <input type="text" class="xp-analysis-field-filter" id="${filterId}" placeholder="${r.get('Analysis_FilterFields')}"/>
                            <div class="xp-analysis-field-list" id="${itemsId}">${itemsHtml}</div>
                        </div>
                    </div>`;

        document.getElementById(containerId).innerHTML = html;

        const updateCount = () => {
            const total = fields.length;
            const checked = $('#' + itemsId + ' input.target-field-items:checked').length;
            document.getElementById(countId).textContent = checked + ' / ' + total;
        };

        $('#' + itemsId + ' input.target-field-items')
            .off('change.analysis')
            .on('change.analysis', () => {
                updateCount();
                this._refreshPkGeomChoices();
            });

        $('#' + containerId + ' .xp-analysis-field-toggle')
            .off('click.analysis')
            .on('click.analysis', (evt) => {
                const action = evt.currentTarget.getAttribute('data-action');
                const $visible = $('#' + itemsId + ' .xp-analysis-field-row:visible input.target-field-items');
                $visible.prop('checked', action === 'all');
                updateCount();
                this._refreshPkGeomChoices();
            });

        $('#' + filterId)
            .off('input.analysis')
            .on('input.analysis', (evt) => {
                const q = (evt.target.value || '').toLowerCase();
                $('#' + itemsId + ' .xp-analysis-field-row').each(function () {
                    const text = $(this).find('span').text().toLowerCase();
                    this.style.display = q === '' || text.indexOf(q) !== -1 ? '' : 'none';
                });
            });
    }

    _refreshPkGeomChoices() {
        const items = $('#' + this.panelId + ' .target-field-items');
        const firstEntity = this._selectedRow('first-source');
        const secondEntity = this._selectedRow('second-source');
        const dataSource = [];

        for (let i = 0; i < items.length; i++) {
            const fieldItem = items[i];
            if (!fieldItem.checked) {
                continue;
            }
            const id = $(fieldItem).attr('ref-id');
            const ds = $(fieldItem).attr('datasource');
            let field;
            let dataType;
            let srid;

            const fields = ds === 'first' ?
                (firstEntity.fields ?? this._combo('first-source-fields').dataSource.data()) :
                (secondEntity.fields ?? this._combo('second-source-fields').dataSource.data());

            if (ds === 'first') {
                //const fieldVal = this._combo('first-source-fields').dataSource.data().find(row => row.Id == id);
                const fieldVal = fields.find(row => row.Id == id);
                field = firstEntity.Id < 0
                    ? firstEntity.Key + '.' + fieldVal.Name
                    : firstEntity.Key + '.' + fieldVal.FieldName;
                dataType = fieldVal.DataType;
                srid = fieldVal.Srid;
            } else {
                const fieldVal = fields.find(row => row.Id == id);
                field = secondEntity.Id < 0
                    ? secondEntity.Key + '.' + fieldVal.Name
                    : secondEntity.Key + '.' + fieldVal.FieldName;
                dataType = fieldVal.DataType;
                srid = fieldVal.Srid;
            }
            dataSource.push({ Id: field, FieldName: field, DataType: dataType, Srid: srid });
        }

        this._addExtraPkGeomItems(dataSource);

        const pkFields = dataSource.filter(f => f.DataType === 'INTEGER' || f.DataType === 'NUMERIC' || f.DataType === 'STRING' || f.DataType == null);
        this._setComboData('analysis-pk-field', pkFields);
        const geomFields = dataSource.filter(f => f.DataType === 'GEOMETRY' || f.DataType == null);
        this._setComboData('analysis-geom-field', geomFields);
    }

    _addExtraPkGeomItems(dataSource) {
    }

    _fieldRef(entity, field) {
        const ref = { Type: 'Field', DataSourceKey: entity.Key };
        if (entity.Kind === 'Analysis') {
            ref.FieldName = field.FieldName;
        } else {
            ref.IdField = field.Id;
        }
        return ref;
    }

    _applySource(target, entity) {
        if (entity.Kind === 'Analysis') {
            target.Type = 'XPQUERY_INSTANT',
                target.XpQuery = entity.XpQuery;
        } else if (entity.Id < 0) {
            target.Type = 'EXT_ENTITY',
                target.Id = Math.abs(entity.Id);
        } else {
            target.Type = 'ENTITY',
                target.Id = entity.Id;
        }
        target.Key = entity.Key;
    }

    _collectTargetFields(entity, fieldsComboName, itemsContainerName, outputValues) {
        const items = $('#' + this._id(itemsContainerName) + ' input');
        for (let i = 0; i < items.length; i++) {
            const targetField = $(items[i]);
            if (!targetField[0].checked) {
                continue;
            }
            const fieldDescription = entity.fields
                .find(row => row.Id == targetField.attr('ref-id'));
            const output = {
                outputName: entity.Key + '.' + fieldDescription.FieldName,
                type: 'Field',
                dataSourceKey: entity.Key,
                Srid: fieldDescription.Srid
            };
            if (entity.Kind === 'Analysis') {
                output.FieldName = fieldDescription.FieldName;
            } else {
                output.IdField = fieldDescription.Id;
            }
            outputValues.push(output);
        }
    }

    _getPanelTitle() { throw new Error('Subclass must override _getPanelTitle'); }
    _getFormBody() { throw new Error('Subclass must override _getFormBody'); }
    _wireWizardEvents() { throw new Error('Subclass must override _wireWizardEvents'); }
    _buildAnalysisPayload() { throw new Error('Subclass must override _buildAnalysisPayload'); }
}
